'use client';

import type { TagData } from 'src/types/tag-data';
import { isNil } from 'es-toolkit';

import { ActiveTagsFilterDropdown } from './active-tags-filter-dropdown';

type ActiveTagsFilterProps = {
  readonly tags: readonly TagData[];
  readonly selectedTagIds: readonly string[];
  readonly onRemoveTag: (tagId: string) => void;
  readonly onToggleTag: (tagId: string) => void;
  readonly onClearAll: () => void;
  readonly filterLabel: string;
};

export function ActiveTagsFilter({
  tags,
  selectedTagIds,
  onRemoveTag,
  onToggleTag,
  onClearAll,
  filterLabel,
}: ActiveTagsFilterProps) {
  const selectedTags = selectedTagIds
    .map((tagId) => {
      const tag = tags.find((t) => t.id === tagId);
      return tag ? { id: tag.id, name: tag.name, hexColorCode: tag.hexColorCode, emoji: tag.emoji } : null;
    })
    .filter((tag): tag is TagData => !isNil(tag));

  if (selectedTags.length === 0) return null;

  const MAX_VISIBLE_TAGS = 3;
  const visibleTags = selectedTags.slice(0, MAX_VISIBLE_TAGS);
  const remainingCount = selectedTags.length - MAX_VISIBLE_TAGS;
  const hasMoreTags = remainingCount > 0;

  return (
    <ActiveTagsFilterDropdown
      allTags={tags}
      selectedTagIds={selectedTagIds}
      onToggleTag={onToggleTag}
      onClearAll={onClearAll}
      visibleTags={visibleTags}
      remainingCount={remainingCount}
      hasMoreTags={hasMoreTags}
      onRemoveTag={onRemoveTag}
      filterLabel={filterLabel}
    />
  );
}
